<template>
  <div class="animated fadeIn pesananpermanenfrm">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.CustInfo"
              @keyup.13.native="lkuKoranCustShow=true"
              :state="!$v.model.customer_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn
                text="Button"
                id="btnKoranCust"
                @click="lkuKoranCustShow=true"
                :disabled="isEdit"
              >
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <!-- <b-form-input class="ml-1" v-model="customer.CustName" readonly></b-form-input> -->
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
              <b-form-checkbox class="ml-1 mt-2" v-model="model.bill2group" value="1" unchecked-value="0">SubAgen (Billing ke Induk)</b-form-checkbox>
          </b-input-group>
          <b-input-group v-if="(model.bill2group==1)">
            <b-input-group-prepend><label>Induk/Billing Ke</label></b-input-group-prepend>
            <b-form-input
              readonly v-b-tooltip.hover title="INDUK AGEN"
              v-model="model.Bill2CustInfo" :state="!$v.model.Bill2CustId.$error"
              @keyup.13.native="lkuKoranCustShow=true"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranBill2CustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
                <b-btn text="Button"  class="ml-1" v-on:click="clearHolding()">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat Penagihan</label>
            </b-input-group-prepend>
            <b-form-input v-model="customer.billingAddr1" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <b-form-input v-model="customer.billingAddr2" readonly class="mt-1"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat Pengiriman</label>
            </b-input-group-prepend>
              <b-form-textarea v-model="model.address" :state="!$v.model.address.$error" rows="2" max-rows="5"></b-form-textarea>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Rute</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.jurusan_info"
              @keyup.13.native="lkuKoranJurusanShow=true"
              :state="!$v.model.jurusan_id.$error"
              placeholder="Pilih Jurusan"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Titik Drop</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.titikdrop" placeholder="Drop point"></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranAgenShow=true" v-b-tooltip.hover title="Drop ke Agen (Kirim via Agen)">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Kota/Wilayah</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              :state="!$v.model.kota_id.$error"
              placeholder="Pilih Kota/Area"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales Executive</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.salesae_name"
              @keyup.13.native="lkuKoranSalesShow=true"
              placeholder="Pilih Sales Executive"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <label class="text-right">Kolektor</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.collector_name"
              @keyup.13.native="lkuKoranColectorShow=true"
              placeholder="Pilih Kolektor"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranColectorShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Pengakuan Revenue</label>
            </b-input-group-prepend>
            <b-form-radio-group v-model="model.unearned" class="mt-1">
              <b-form-radio :value="1">Didepan(UnEarned) </b-form-radio>
              <b-form-radio :value="0">Sesuai pengiriman</b-form-radio>
            </b-form-radio-group>

          </b-input-group>


        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.kiriman_name" :state="!$v.model.kiriman_code.$error" readonly placeholder="Kode Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>

          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Harga Koran ({{uanguser}})</label>
            </b-input-group-prepend>
            <b-input-group-prepend >
              <span class="input-group-text">eceran</span>
            </b-input-group-prepend>
            <v-number
              class="form-control text-right col-lg-3"
              separator=","
              v-model="model.hrg_agen_ecer"
              :state="!$v.model.hrg_agen_ecer.$error"
            ></v-number>
          </b-input-group>
          <b-row>
            <b-col lg="10" xl="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tanggal Buka/Mulai</label>
                </b-input-group-prepend>
                    <b-input-group-prepend is-text>
                      <i class="fa fa-calendar"></i>
                    </b-input-group-prepend>
                    <b-input-group-append>
                      <span
                        class="input-group-text"
                        style="width:100px;"
                        v-if="(model.tglbuka)"
                      >{{ model.tglbuka | moment("dddd")}}</span>
                    </b-input-group-append>

                  <b-form-input
                    type="date"
                    v-model="model.tglbuka"
                    :state="!$v.model.tglbuka.$error"
                  ></b-form-input>
              </b-input-group>

            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Bts.Akhir Kirim</label>
            </b-input-group-prepend>
            <b-form-radio-group
              v-model="model.isContractBase"
              :options="optionsContractBase"
              class="mt-1"
            ></b-form-radio-group>
              <b-form-input
                type="date"
                v-model="model.tgltutup"
                :state="!$v.model.tgltutup.$error"
                :placeholder="model.isContractBase===1?'Tgl. Akhir Kontrak':null"
                :disabled="(model.isContractBase===0)"
              ></b-form-input>

            <b-input-group-append>
              <b-button
                size="sm"
                class="mr-0"
                text="Button"
                variant="secondary"
                @click="tgltutup = null"
              >Clear</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Status Pengiriman</label>
            </b-input-group-prepend>
            <b-form-radio-group v-model="model.isactive" class="mt-1 mr-2">
              <b-form-radio :value="1">Aktif</b-form-radio>
              <b-form-radio :value="0">Non Aktif</b-form-radio>
            </b-form-radio-group>
            <b-form-input
              v-model="model.remark"
              :state="!$v.model.remark.$error"
              placeholder="Keterangan Status"
              :disabled="(model.isactive==1)"
            ></b-form-input>

          </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Maksimal Hari Retur</label>
                </b-input-group-prepend>
                <b-form-input
                  type="number" 
                      v-model="model.toleransiRetur"
                      :disabled="model.kiriman_code==='LANGGANAN'?true:false"
                      :max="100"
                ></b-form-input>
                 <b-input-group-append><span class="input-group-text">Hari</span></b-input-group-append>
                <b-input-group-prepend>
                  <span class="p-2">Max. Jml. Retur per hari</span>
                </b-input-group-prepend>
                <b-form-input
                  type="number" 
                  v-model="model.max_retur"
                  :disabled="model.kiriman_code==='LANGGANAN'?true:false"
                      :min="0" :max="100"
                ></b-form-input>
                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
              </b-input-group>

          <div class="mt-1">
            <p class="text-center font-weight-bolder" style="width:100%; margin-bottom:2px;">Pola Kiriman  <span v-if="(model.gratis==1)" style="background-color:gold;">&nbsp; GRATIS &nbsp;</span> </p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width:80px;">Senin</th>
                  <th style="width:80px;">Selasa</th>
                  <th style="width:80px;">Rabu</th>
                  <th style="width:80px;">Kamis</th>
                  <th style="width:80px;">Jumat</th>
                  <th style="width:80px;">Sabtu</th>
                  <th style="width:80px;">Minggu</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.seninEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.selasaEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.rabuEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.kamisEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.jumatEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.sabtuEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.mingguEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-input-group>
            <b-input-group-prepend>
              <label>&nbsp;</label>
            </b-input-group-prepend>
            <b-form-checkbox class="mt-1 mr-2" v-model="model.epaper" value="1" unchecked-value="0">Langganan E-PAPER</b-form-checkbox>
            <b-input-group-prepend v-if="(model.epaper==1)">
              <span class="input-group-text">Harga e-Paper ({{uanguser}})</span>
            </b-input-group-prepend>
            <v-number v-if="(model.epaper==1)"
              class="form-control text-right col-lg-3" v-b-tooltip.hover title="Harga e-Paper per Hari"
              separator=","
              v-model="model.hrg_epaper"
            ></v-number>
            <b-input-group-append v-if="(model.epaper==1)">
              <span class="input-group-text">/ hari</span>
            </b-input-group-append>

          </b-input-group>

        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranBill2CustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranBill2Cust"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranKirimanCodeShow"
      size="lg"
      :hide-footer="true"
      title="Jenis Kiriman"
      :centered="true"
    >
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman"></lku-koranjeniskiriman>
    </b-modal>

    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List of Jurusan/Ekspedisi"
      :centered="true"
    >
      <lku-koran-jurusan @click="onSelectKoranJurusan"></lku-koran-jurusan>
    </b-modal>

    <b-modal
      v-model="lkuKoranKotaShow" size="lg"
      :hide-footer="true"
      title="List of Kota Layanan"
      :centered="true"
    >
      <lku-koran-kota @click="onSelectKoranKota"></lku-koran-kota>
    </b-modal>

    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List of Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectSalese" crudfilter="koran=1"></lku-salesae>
    </b-modal>

    <b-modal
      v-model="lkuKoranColectorShow"
      size="lg"
      :hide-footer="true"
      title="List of Collector"
      :centered="true"
    >
      <lku-collector @click="onSelectCollector"></lku-collector>
    </b-modal>

    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="Kirim via Agen (drop ke Agen)"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" customer_group="KORANAGEN"></lku-koran-cust>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
  .pesananpermanenfrm{
    table {
      border: none;
      font-size: smaller;
      th {
        border-bottom: 1px solid #d1d1d1;
        padding: 0 15px;
        height: 30px;
        background: #e8e8e8;
      }
    }
  }
</style>

<script>
import { validationMixin } from "vuelidate";
import {required} from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import vNumber from "vue-numeric";
import Loading from "vue-loading-overlay";
import customer from "../../apis/customer";
import pesanan_pascabayar from "../../apis/koran_pesanan_pascabayar";
import lkuKoranCust from "../lookup/lkuKoranCust";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";
import lkuKoranJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranKota from "../lookup/lkuKoranKota";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";
import moment from "moment";
toastr.init();

export default {
  components: {
    lkuKoranCust,
    lkuKoranJurusan, lkuKoranjeniskiriman, 
    lkuKoranKota,
    lkuSalesae,
    lkuCollector,
    vNumber,
    Loading
  },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      Bill2CustId: {
        required: function() {
          if (this.model.bill2group == 0) {
            return true;
          } else if (!(this.model.Bill2CustId)) {
            return false;
          } else return true;
        }
      },
      jurusan_id: { required },
      kota_id: { required },
      // salesae_id: { required },
      // collector_id: { required },
      kiriman_code: { required },
      isactive: { required },
      tglbuka: { required },
      // isContractBase: { required },
      tgltutup: {
        required: function() {
          if (this.model.isContractBase == 0) {
            return true;
          } else if (!this.model.tgltutup || this.model.tgltutup === null) {
            return false;
          } else return true;
        }
      },
      remark: {
        required: function() {
          if (this.model.isactive == 1) {
            this.model.remark = "";
            return true;
          } else if (!this.model.remark) {
            return false;
          } else return true;
        }
      },
      hrg_agen_ecer: { required },
      address: { required }
      // max_retur: { required }
    }
  },
  data() {
    return {
      isEdit: false,
      isLoading: true,
      saveEnabled: true,
      lkuKoranAgenShow: false,
      lkuKoranCustShow: false,
      lkuKoranBill2CustShow: false,
      lkuKoranKirimanCodeShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKotaShow: false,
      lkuKoranSalesShow: false,
      lkuKoranColectorShow: false,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:moment().format('YYYY-MM-DD'),
      uanguser: this.$store.state.user.matauang,
      model: {
        customer_id: null,
        Bill2CustId: null,
        Bill2CustInfo: null,
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        salesae_name: null,
        address: null,
        kota_id: null,
        collector_id: null,
        collector_name: null,
        tglbuka: moment(new Date()).format("YYYY-MM-DD"),
        isContractBase: 0,
        tgltutup: null,
        isactive: 1,
        remark: "",
        hrg_agen_ecer: 0,
        seninEcer: 0,
        selasaEcer: 0,
        rabuEcer: 0,
        kamisEcer: 0,
        jumatEcer: 0,
        sabtuEcer: 0,
        mingguEcer: 0,
        subagen: 0,
        max_retur:0,
        toleransiRetur:31,
        unearned: 0
      },
      optionsContractBase: [
        { text: "Seterusnya (Tanpa Kontrak)", value: 0 },
        { text: "Sesuai Kontrak", value: 1 }
      ],
      customer: {},
      customerGroups: [],
      taxBussinesGroups: [],
      jeniskiriman: [],
      mode: "single",
      formats: {
        dayPopover: "WWW, MMM D, YYYY"
      },
      tglbuka: new Date(),
      tgltutup: null,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      // console.log(this.$v.model.$touch());
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.isContractBase": function (val) {
      if (val === 0) {
        this.tgltutup = null;
        return;
      }
      this.model.isContractBase = val;
    },
    tglbuka(val) {
      if (val !== null) {
        this.model.tglbuka = moment(new Date(val)).format("YYYY-MM-DD");
      }
    },
    tgltutup(val) {
      this.model.tgltutup = null;
      if (val !== null) this.model.tgltutup = moment(val).format("YYYY-MM-DD");
    },
    address(val){
      this.model.address = val;
    }
  },
  created: async function() {
    // const a = await crud.list({ tablename: "koranjeniskiriman", limit: 1000 });
    // this.jeniskiriman = a.reduce((newArr = [], el, idx) => {
    //   newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
    //   return newArr;
    // }, []);

    if (this.$route.params.pascabayarkey) {
      this.isEdit = true;
      this.isLoading = true;
      const resp = await pesanan_pascabayar.detail(this.$route.params);
      const detail = resp;
      // console.log('detail',detail);
      detail.tglbuka =
        detail && detail.tglbuka !== null
          ? moment(detail.tglbuka).format("YYYY-MM-DD")
          : moment(new Date()).format("YYYY-MM-DD");
      this.model = detail;
      this.model.CustInfo = `${detail.CustCode} | ${detail.CustName}`;
      if (this.model.Bill2CustId) {
        this.model.Bill2CustInfo = `${detail.Bill2CustCode || detail.CustCode} | ${detail.Bill2CustName || detail.CustName}`;
        this.model.Bill2CustCode = `${detail.Bill2CustCode || detail.CustCode}`;
        this.model.Bill2CustName = `${detail.Bill2CustName || detail.CustName}`;
      } 
      // else {
      //   this.model.Bill2CustInfo = `${detail.CustCode} | ${detail.CustName}`;
      //   this.model.Bill2CustCode = detail.CustCode;
      //   this.model.Bill2CustName = detail.CustName;
      //   this.model.Bill2CustId = this.model.customer_id;
      // }
      const customer_ = await customer.detail(detail);
      this.customer = customer_[0];
      this.model.address =
        detail.DeliveryAddr ||
        `${(this.customer.Address1 || "").trim()} ${(
          this.customer.Address2 || ""
        ).trim()} ${this.customer.City}`;

      this.model.isContractBase = detail.isContractBase;
      if (detail.tglbuka) {
        this.tglbuka = new Date(detail.tglbuka);
      }
      if (detail.tgltutup) {
        this.tgltutup = new Date(detail.tgltutup);
      }
      this.customer.billingAddr1 = `${(this.customer.Address1 || "").trim()} ${(
        this.customer.Address2 || ""
      ).trim()} `;

      this.customer.billingAddr2 = `${this.customer.City} ${
        this.customer.PostCode !== null
          ? ". Kode pos: " + this.customer.PostCode
          : ""
      } `;
      this.isLoading = false;
    }
    this.isLoading = false;
  },
  methods: {
    changeTouchModal() {
      // console.log("changeTouchModal");
      this.$v.model.$touch();
    },
    // changeJnsKiriman() {
    //   if (this.model.kiriman_code === "LANGGANAN") {
    //     this.model.max_retur = 0;
    //   } else {
    //     this.model.max_retur = 100;
    //   }
    // },
    // changeDate(props, event) {
      // console.log("props", props);
      // console.log("event", event);
    // },
    onSelectKoranAgen(_selected) {
      if (this.model.customer_id === _selected.customer_id) {
            toastr.error("Pilih Customer yang berbeda !.");
      } else {
          this.model.titikdrop = _selected.CustName;
          this.lkuKoranAgenShow = false;
      }
    },

    onSelectSalese:  function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.salesae_name = `${_sales.crewname || _sales.salesae_name}`;
      this.lkuKoranSalesShow = false;
    },
    onSelectCollector: async function(_collec) {
      this.model.collector_id = _collec.collector_id;
      this.model.collector_name = `${_collec.crewname}`;
      this.lkuKoranColectorShow = false;
    },
    clearHolding: function () {
        this.lkuGroupShow=true;
        this.model.holding = '';
        this.model.Bill2CustNo = '';
        this.model.Bill2CustName = '';
        this.model.Bill2CustId = '';
        this.model.bill2group = 0
    },

    onSelectKoranCust: async function(_selected) {
      // this.clearModel();
      if (_selected && _selected.customer_id) {
        this.lkuKoranCustShow = false;

        if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = _selected.salesae_name;
        }
        if (!(this.model.kota_id)) {
          this.model.kota_id = _selected.kota_id;
          this.model.kota_name = _selected.kota_name;
        }
        if (!(this.model.jurusan_id)) {
          this.model.jurusan_id = _selected.jurusan_id;
          this.model.jurusan_name = _selected.jurusan_name;
          this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
        }
        if (!(this.model.titikdrop)) {
          this.model.titikdrop = _selected.titikdrop;
        }
        if (_selected.Bill2CustId){
          this.model.Bill2CustId = `${_selected.Bill2CustId}`;
          this.model.Bill2CustInfo = `${_selected.Bill2CustNo} | ${_selected.Bill2CustName}`;
          this.model.bill2group = _selected.bill2group;
        } else {
          this.model.Bill2CustId = `${_selected.customer_id}`;
          this.model.Bill2CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
        }

          this.tglbuka = new Date();
          this.model.tglbuka === moment(new Date()).format("YYYY-MM-DD");

          if (_selected.DeliveryAddr) {
            this.model.address = _selected.DeliveryAddr;
          } else {
            this.model.address = `${_selected.Address1} ${
              _selected.Address2 !== null ? _selected.Address2 : ""
                } ${_selected.City}`;
          }

          this.model.customer_id = _selected.customer_id;
          this.model.CustCode = _selected.CustCode;
          this.model.CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
          
          this.customer = _selected;
          this.customer.billingAddr1 = `${_selected.Address1} ${
            _selected.Address2 !== null ? _selected.Address2 : ""
          }`;
          this.customer.billingAddr2 = `${_selected.City} ${
            _selected.PostCode !== null
              ? ".Kode Pos :" + _selected.PostCode
              : ""
          }`;
        // }

        this.isLoading = false;
      }
    },
    onSelectKoranBill2Cust: function(_selected) {
      // if (_selected.customer_id) {
        this.model.Bill2CustId = _selected.customer_id;
        this.model.Bill2CustNo = _selected.CustCode;
        this.model.Bill2CustInfo = `${_selected.CustCode} | ${_selected.CustName}`;
      // }
      console.log('this.model.Bill2CustId: ', this.model.Bill2CustId);
      this.lkuKoranBill2CustShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.lkuKoranKirimanCodeShow = false;
      this.model.kiriman_name = _selected.kiriman_name;
      this.model.kiriman_code = _selected.kiriman_code;
      if (!(this.model.hrg_agen_ecer)) {
          this.model.hrg_agen_ecer = _selected.harga || 0;
      }
    },

    onSelectKoranJurusan: async function(_selected) {
      this.model.jurusan_id = _selected.jurusan_id;
      this.model.jurusan_name = _selected.jurusan_name;
      this.model.jurusan_info =
        _selected.jurusan_code + " | " + _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranKota: async function(_selected) {
      this.lkuKoranKotaShow = false;
      this.model.kota_id = _selected.kota_id;
      this.model.kota_name = _selected.kota_name;
      if (!(this.model.hrg_agen_ecer)) {
        this.model.hrg_agen_ecer = _selected.hrg_agen_ecer || 0;
      }
      if (_selected.salesae_id){
         if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = `${_selected.crewname || _selected.salesae_name}`;
         }          
      }
    },
    save: async function() {
      this.isLoading = true;
      if (this.invalidModel) {
        this.isLoading = false;
          const invalidobj={};
          for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
              if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
            }
          }        
          console.log('validation model: ', this.$v.model);
          console.log('validation field: ', invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          // this.model.isContractBase = this.isContractBase;
          this.model.DeliveryAddr= this.model.address || '';
          await pesanan_pascabayar.save(this.model);
          toastr.success("Save successfully");
          this.isLoading = false;
          this.close();
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },
    close() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "koran.pesananpermanen" });
      }
    },
    clearModel() {
      this.model = {
        customer_id: null,
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        salesae_name: null,
        address: null,
        kota_id: null,
        collector_id: null,
        collector_name: null,
        isactive: 1,
        hrg_agen_ecer: 0,
        seninEcer: 0,
        selasaEcer: 0,
        rabuEcer: 0,
        kamisEcer: 0,
        jumatEcer: 0,
        sabtuEcer: 0,
        mingguEcer: 0,
      };

      this.tglbuka = new Date();
      this.tgltutup = null;
    }
  }
};
</script>